import axiosInstance from 'services/axiosMiddleware';

export async function updateCoachStatus({ key, coachid }) {
  try {
    const response = await axiosInstance.post('admin/updateCoachStatus', {
      key,
      coachid
    });

    if (response.data.status) {
      return response.data.message; // Return the success message
    } else {
      throw new Error(response.data.message); // Throw an error with the message if status is false
    }
  } catch (error) {
    console.error('Error updating Coach status:', error);
    throw error; // Re-throw the error to be handled by react-query
  }
}
